export default ({ val }, context) => {
	return {
		type: "number",
		value: parseFloat(val) / 100,
		primitive: true,
	};
};